import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import EbayOrdersTable from './components/EbayOrdersTable';
// import NewItemsTable from './components/NewItemsTable';

const EbayOrders = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h5 className="page-title">Orders / ebay</h5>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <EbayOrdersTable />
      </Col>
    </Row>
  </Container>
);

export default EbayOrders;
